module.exports = __webpack_public_path__ + "img/vita.21094836.jpg";